import { DUO_ICONS, type DuoName } from './duo-icons.ts';

/** A two-tone icon (duo-icons.ts): the outline in `color`, the fill in `--duo-fill`. */
export function DuoIcon({ name, size = 24 }: { name: DuoName; size?: number }) {
  return <svg className="duo" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" dangerouslySetInnerHTML={{ __html: DUO_ICONS[name] }} />;
}
